import React, { Component } from 'react'
import { Flex } from 'rebass/styled-components'
import SectionHeading from 'components/SectionHeading'
import ContentWrapper from 'components/ContentWrapper'
import Divider from 'components/Divider'
import Layout from 'components/Layout'
import ContactForm from 'components/ContactForm'

class Contact extends Component {
  render () {
    return (
      <Layout>
        <ContentWrapper>
          <Flex
            p={[2, 4]}
            flexDirection='column'
            sx={{ flex: 1, alignContent: 'stretch' }}
          >
            <SectionHeading center>{`Let's Connect`}</SectionHeading>
            <Divider medium />
            <ContactForm />
          </Flex>
        </ContentWrapper>
      </Layout>
    )
  }
}

// Replace 2nd arg with mapStateToProps when needing to connect to redux
export default Contact
